<ng-container *ngIf="prefix">{{ prefix }}&nbsp;</ng-container>{{ displayValue }}
